import { matchPath } from 'react-router-dom';

function useRouteChecker({ pathname }: { pathname: string }) {
  const isSignUpPage =
    !!matchPath('/sign-up/*', pathname) ||
    !!matchPath('/account-verification/*', pathname) ||
    !!matchPath('/select-plan/*', pathname) ||
    !!matchPath('/confirm-payment/*', pathname) ||
    !!matchPath('/success/*', pathname);
  return {
    isSignUpPage,
  };
}
export default useRouteChecker;
